"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const i18next_1 = __importDefault(require("i18next"));
const mobx_1 = require("mobx");
const apis_1 = require("../../api/sulu/apis");
const configuration_1 = __importDefault(require("../apis/configuration/sulu/configuration"));
const compare_1 = require("../helper/compare");
class SuluResellers {
    api = new apis_1.ResellerApi(configuration_1.default);
    loading = false;
    resellersForCountry = new Map();
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            resellersForCountry: mobx_1.observable,
            loadResellers: mobx_1.action.bound,
            isLoading: mobx_1.computed,
            setResellersForCountry: mobx_1.action.bound,
        });
    }
    getResellersForCountry(country) {
        return this.sortResellers(this.resellersForCountry.get(country) ?? null);
    }
    getResellersForCountryWithExternalId(country) {
        return this.sortResellers(this.resellersForCountry
            .get(country)
            ?.filter((reseller) => !!reseller.externalId) ?? null);
    }
    getResellersForCountryWithExternalIdOptions(country) {
        return (this.getResellersForCountryWithExternalId(country)?.map((reseller) => {
            return {
                value: reseller.externalId,
                label: reseller.name,
            };
        }) ?? []);
    }
    loadResellers(country) {
        if (this.resellersForCountry.has(country)) {
            return Promise.resolve();
        }
        this.loading = true;
        return this.api
            .getAllReseller({ country })
            .then((resellers) => {
            this.setResellersForCountry(country, resellers);
        })
            .finally(() => {
            this.loading = false;
        });
    }
    get isLoading() {
        return this.loading;
    }
    sortResellers(resellers) {
        if (null === resellers) {
            return null;
        }
        return resellers.sort((a, b) => (0, compare_1.naturalCompare)(a.name, b.name, i18next_1.default.language));
    }
    setResellersForCountry(country, resellers) {
        this.resellersForCountry.set(country, resellers);
    }
}
__decorate([
    bind_decorator_1.default
], SuluResellers.prototype, "getResellersForCountry", null);
__decorate([
    bind_decorator_1.default
], SuluResellers.prototype, "getResellersForCountryWithExternalId", null);
__decorate([
    bind_decorator_1.default
], SuluResellers.prototype, "getResellersForCountryWithExternalIdOptions", null);
__decorate([
    bind_decorator_1.default
], SuluResellers.prototype, "sortResellers", null);
exports.default = new SuluResellers();
